import React, { useState } from "react";
import "./ticTacToe.style.css";
import ConfettiEffect from "../../confetti/confetti.component";
import { IT_IS_A_DRAW, NEXT_PLAYER, RESET_GAME, WINNER } from "../../../helper/texts/variables";

function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}

const TicTacToe = () => {
  const initialBoard = Array(9).fill(null);
  const [board, setBoard] = useState(Array(9).fill(null));
  const [xIsNext, setXIsNext] = useState(true);

  const handleClick = (index) => {
    const squares = [...board];
    if (calculateWinner(squares) || squares[index]) {
      return;
    }
    squares[index] = xIsNext ? "X" : "O";
    setBoard(squares);
    setXIsNext(!xIsNext);
  };

  const renderSquare = (index) => {
    return (
      <button className="square" onClick={() => handleClick(index)}>
        {board[index]}
      </button>
    );
  };

  const winner = calculateWinner(board);
  const isBoardFull = board.every((square) => square !== null);

  let status;
  if (winner) {
    status = `${WINNER}: ${winner}`;
  } else if (isBoardFull) {
    status = `${IT_IS_A_DRAW}`;
  } else {
    status = `${NEXT_PLAYER}: ${xIsNext ? "X" : "O"}`;
  }

  const resetGame = () => {
    setBoard(initialBoard);
    setXIsNext(true);
  };

  return (
    <div id="container">
      {winner && <ConfettiEffect />}
      <div className="status">
        <h3>{status} </h3>
      </div>
      <div className="board-row">
        {renderSquare(0)}
        {renderSquare(1)}
        {renderSquare(2)}
      </div>
      <div className="board-row">
        {renderSquare(3)}
        {renderSquare(4)}
        {renderSquare(5)}
      </div>
      <div className="board-row">
        {renderSquare(6)}
        {renderSquare(7)}
        {renderSquare(8)}
      </div>
      <button className="resetButton" onClick={resetGame}>
        {RESET_GAME}
      </button>
    </div>
  );
};

export default TicTacToe;
